import { BotFlow, IntentListItem, IntentListItemId, NlpModelId } from '@feedyou-ai/feedbot-schema'

import { isHeadline, isIntent } from '../../features/nlpIntentList'

export function getNlpModelById(flow: BotFlow | undefined, modelId: NlpModelId) {
  return flow?.nlp?.models?.find(({ id }) => id === modelId)
}

export function findIntentListItem(list: IntentListItem[] | undefined, id: IntentListItemId) {
  return list?.find(({ id: itemId }) => itemId === id)
}

export const findIntent = (list: IntentListItem[] | undefined, id: IntentListItemId) => {
  const item = findIntentListItem(list, id)
  return item && isIntent(item) ? item : undefined
}

export const findIntentHeadline = (list: IntentListItem[] | undefined, id: IntentListItemId) => {
  const item = findIntentListItem(list, id)
  return item && isHeadline(item) ? item : undefined
}
